// extracted by mini-css-extract-plugin
export var parcelRow = "_ro-0";